
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue } from "../../../Components/Text.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { Msg } from "./Types.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SystemRoleSettingsDto } from "../../../Shared/Roles.js";
import { InformationTooltip } from "../../../Components/InformationTooltip.js";
import { NumberInput } from "../../../Components/Input.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { unwrap, map } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { FormState__getValidation } from "../../../Shared/Shared.js";
import { ErrorAlert } from "../../../Components/Alert.js";
import { Button } from "../../../Components/Button.js";

function InventoryNumberConfiguration(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.inventory.inventory_number_configuration"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = [Checkbox({
        ComponentState: componentState,
        IsChecked: props.InventoryNumberConfiguration.InventoryNumberUnique,
        Label: t("settings.inventory.inventory_number_unique"),
        OnCheck: (value_2) => {
            props.Dispatch(new Msg(0, [value_2]));
        },
        TestId: "inventory-number-unique",
    }), Checkbox({
        ComponentState: componentState,
        IsChecked: props.InventoryNumberConfiguration.InventoryNumberAutomaticIncrease,
        Label: t("settings.inventory.inventory_number_editable"),
        OnCheck: (value_3) => {
            props.Dispatch(new Msg(1, [value_3]));
        },
        TestId: "inventory-number-editable",
    }), Checkbox({
        ComponentState: componentState,
        IsChecked: props.InventoryNumberConfiguration.AllowQRCodeAssignmentMultipleTimes,
        Label: t("settings.inventory.allow_qr_code_assignment_multiple_times"),
        OnCheck: (value_4) => {
            props.Dispatch(new Msg(2, [value_4]));
        },
        TestId: "allow-qr-code-assignment-multiple-times",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function CommercialDataConfiguration(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.RoleSettings.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.commercial_data.commercial_data_configuration"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = [Checkbox({
        ComponentState: componentState,
        IsChecked: props.RoleSettings.Settings.UserCanSeeCommercialData,
        Label: t("settings.commercial_data.user_visibility_option"),
        OnCheck: (value_2) => {
            props.RoleSettings.OnUpdate((settings) => (new SystemRoleSettingsDto(settings.ToolManagerReceiverWriteTypes, settings.ToolManagerReceiverArchiveTypes, settings.ToolManagerCanDeleteInventory, settings.ToolManagerCanSeeCommercialData, settings.UserCanSeeAllInventory, value_2, settings.UserCanWriteNotices, settings.UserCanReserveForSelf, settings.UserReservationReceiverTypes, settings.UserVisibleReceiverTypes, settings.AllRolesReceiveNotificationEmails, settings.UserCanUseGlobalAppSearch, settings.AssignToUserViaSelection)));
        },
        TestId: "user-manager-visible",
    }), Checkbox({
        ComponentState: componentState,
        IsChecked: props.RoleSettings.Settings.ToolManagerCanSeeCommercialData,
        Label: t("settings.commercial_data.tool_manager_visibility_option"),
        OnCheck: (value_3) => {
            props.RoleSettings.OnUpdate((settings_1) => (new SystemRoleSettingsDto(settings_1.ToolManagerReceiverWriteTypes, settings_1.ToolManagerReceiverArchiveTypes, settings_1.ToolManagerCanDeleteInventory, value_3, settings_1.UserCanSeeAllInventory, settings_1.UserCanSeeCommercialData, settings_1.UserCanWriteNotices, settings_1.UserCanReserveForSelf, settings_1.UserReservationReceiverTypes, settings_1.UserVisibleReceiverTypes, settings_1.AllRolesReceiveNotificationEmails, settings_1.UserCanUseGlobalAppSearch, settings_1.AssignToUserViaSelection)));
        },
        TestId: "tool-manager-visible",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ToolManagerDeletePermissionConfiguration(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.RoleSettings.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.inventory.delete_permission_configuration"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = [Checkbox({
        ComponentState: componentState,
        IsChecked: props.RoleSettings.Settings.ToolManagerCanDeleteInventory,
        Label: t("settings.inventory.tool_manager_can_delete_inventory"),
        OnCheck: (value_2) => {
            props.RoleSettings.OnUpdate((settings) => (new SystemRoleSettingsDto(settings.ToolManagerReceiverWriteTypes, settings.ToolManagerReceiverArchiveTypes, value_2, settings.ToolManagerCanSeeCommercialData, settings.UserCanSeeAllInventory, settings.UserCanSeeCommercialData, settings.UserCanWriteNotices, settings.UserCanReserveForSelf, settings.UserReservationReceiverTypes, settings.UserVisibleReceiverTypes, settings.AllRolesReceiveNotificationEmails, settings.UserCanUseGlobalAppSearch, settings.AssignToUserViaSelection)));
        },
        TestId: "tool-manager-can-delete-inventory",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function PlannedReturnDateMandatoryConfiguration(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.inventory.tool_assignment_configuration"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = [Checkbox({
        ComponentState: componentState,
        IsChecked: props.InventoryConfiguration.PlannedReturnDateMandatory,
        Label: t("settings.inventory.planned_return_date_mandatory"),
        OnCheck: (value_2) => {
            props.Dispatch(new Msg(4, [value_2]));
        },
        TestId: "planned-return-date-mandatory",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function SetReturnCompletenessConfiguration(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const scanOnlyComponentState = (props.FormState.IsLoading ? true : !props.InventoryConfiguration.CompletenessCheckOnSetReturnRequired) ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.inventory.set_return_configuration"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems = [Checkbox({
        ComponentState: componentState,
        IsChecked: props.InventoryConfiguration.CompletenessCheckOnSetReturnRequired,
        Label: t("settings.inventory.set_return_completeness_check_required"),
        OnCheck: (value_2) => {
            props.Dispatch(new Msg(5, [value_2]));
        },
        TestId: "set-return-completeness-check-required",
    }), Checkbox({
        ComponentState: scanOnlyComponentState,
        IsChecked: props.InventoryConfiguration.CompletenessCheckOnSetReturnScanOnly,
        Label: t("settings.inventory.set_return_completeness_check_scan_only"),
        OnCheck: (value_3) => {
            props.Dispatch(new Msg(6, [value_3]));
        },
        TestId: "set-return-completeness-check-scan-only",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function BookingHistoryRetentionYearsConfiguration(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("settings.booking_history_retention_years.title"),
    }), createElement(InformationTooltip, {
        Content: t("settings.booking_history_retention_years.information_alert"),
        TestId: "booking-history-retention-years-tooltip",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = [createElement(NumberInput, {
        ComponentState: componentState,
        Label: t("settings.booking_history_retention_years.year_input_label"),
        MaxValue: numberInputIntMaxValue,
        OnChange: (value_6) => {
            props.Dispatch(new Msg(3, [map((value_7) => (~~value_7 | 0), value_6)]));
        },
        TestId: "booking-history-retention-years-number-input-test-id",
        Value: unwrap(map((value_5) => value_5, props.InventoryConfiguration.BookingHistoryRetentionYears)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function InventoryNumberSettings(props) {
    let elems_1;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const t = useTranslation()[0];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    const matchValue = state_1.InventoryConfiguration;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        const inventoryConfiguration = matchValue.fields[0];
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems_1 = toList(delay(() => append(singleton(createElement(InventoryNumberConfiguration, {
            Dispatch: dispatch,
            FormState: state_1.FormState,
            InventoryNumberConfiguration: inventoryConfiguration,
            UserData: props.UserData,
        })), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = props.SystemRoleSettings, (matchValue_1 == null) ? (empty()) : singleton(createElement(CommercialDataConfiguration, {
                RoleSettings: matchValue_1,
            }))), delay(() => append(singleton(createElement(BookingHistoryRetentionYearsConfiguration, {
                Dispatch: dispatch,
                FormState: state_1.FormState,
                InventoryConfiguration: inventoryConfiguration,
                UserData: props.UserData,
            })), delay(() => append(singleton(createElement(PlannedReturnDateMandatoryConfiguration, {
                Dispatch: dispatch,
                FormState: state_1.FormState,
                InventoryConfiguration: inventoryConfiguration,
                UserData: props.UserData,
            })), delay(() => append(singleton(createElement(SetReturnCompletenessConfiguration, {
                Dispatch: dispatch,
                FormState: state_1.FormState,
                InventoryConfiguration: inventoryConfiguration,
                UserData: props.UserData,
            })), delay(() => {
                let matchValue_2;
                return append((matchValue_2 = props.SystemRoleSettings, (matchValue_2 == null) ? (empty()) : singleton(createElement(ToolManagerDeletePermissionConfiguration, {
                    RoleSettings: matchValue_2,
                }))), delay(() => {
                    let matchValue_3;
                    return append((matchValue_3 = FormState__getValidation(state_1.FormState, t, "global"), (matchValue_3 == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                        Label: matchValue_3,
                    }))), delay(() => {
                        let elems;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems = [createElement(Button, {
                            ComponentState: componentState,
                            Label: t("general.save"),
                            OnClick: () => {
                                dispatch(new Msg(8, []));
                            },
                            TestId: "update-inventory-number-configuration",
                            Variant: "primary",
                        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                    }));
                }));
            }))))))));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
}

